import { PUBLIC_PREVIEW } from "$env/static/public";
import type { ISbResult } from "@storyblok/svelte";
// import { getPage } from '../../api/serviceController';

// export const prerender = true;

export async function load({ params, url, fetch }) {
  const preview = PUBLIC_PREVIEW === "true";
  let slug = params.slug;

  const isCareersInnerPage =
    slug.includes("careers/open-roles") && !isNaN(+slug.slice(-1));
  let careersResponse = null;

  if (isCareersInnerPage) {
    const careersFetch = await fetch(
      `/api/careers?id=${slug.split("careers/open-roles/")[1]}`,
    );
    careersResponse = await careersFetch.json();
    slug = "/careers/open-roles";
  }

  const fetch_response = await fetch("/api/page", {
    method: "POST",
    body: JSON.stringify({ preview: preview, slug: slug }),
    headers: {
      "content-type": "application/json",
    },
  });

  const text = await fetch_response.text();
  let response: ISbResult | undefined;

  try {
    response = JSON.parse(text);
  } catch (error) {
    console.warn(`Invalid response from API: "${text}"`);
  }

  // Get post preview data if is a blog post
  let postPreviewData;
  try {
    if (
      ["post", "postS6"].includes(response?.data?.story?.content?.component)
    ) {
      const res = await fetch("/api/posts", {
        method: "POST",
        body: JSON.stringify({
          by_uuids_ordered: response?.data?.story.uuid,
          per_page: 1,
        }),
      });

      const resJson = await res.json();
      postPreviewData = resJson.data.stories[0];
    }
  } catch (error) {
    console.log(error);
  }

  return {
    story: response?.data.story ?? null,
    postPreview: postPreviewData ?? null,
    careerData: careersResponse ?? null,
    isCareersSingle: careersResponse !== null,
    preview,
    queryParameters: url.searchParams,
  };
}
